import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { addPlan } from 'slice/planSlice';

const initialFormData = {
  name: '',
  price: '',
  duration_days: '',
  description: '',
};

const AddPlan = () => {
  const [formData, setFormData] = useState(initialFormData);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.plan);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!formData.name.trim()) {
      toast('Plan name is required');
      return;
    }

    dispatch(
      addPlan({
        ...formData,
        price: formData.price === '' ? null : Number(formData.price),
        duration_days: formData.duration_days === '' ? null : Number(formData.duration_days),
      })
    );

    toast('Plan added successfully!');
    navigate('/plans');
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Add Plan</h4>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="row mx-4 mt-5">
          <div className="col-lg-6 col-md-6 col-sm-12 mt-3">
            <label htmlFor="planName" className="adminlables">
              Plan Name
            </label>
            <input
              id="planName"
              type="text"
              name="name"
              className="form-control"
              value={formData.name}
              onChange={handleChange}
            />
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12 mt-3">
            <label htmlFor="planPrice" className="adminlables">
              Price
            </label>
            <input
              id="planPrice"
              type="number"
              min="0"
              name="price"
              className="form-control"
              value={formData.price}
              onChange={handleChange}
            />
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12 mt-3">
            <label htmlFor="planDuration" className="adminlables">
              Duration Days
            </label>
            <input
              id="planDuration"
              type="number"
              min="0"
              name="duration_days"
              className="form-control"
              value={formData.duration_days}
              onChange={handleChange}
            />
          </div>
          <div className="col-12 mt-3">
            <label htmlFor="planDescription" className="adminlables">
              Description
            </label>
            <textarea
              id="planDescription"
              rows={5}
              name="description"
              className="form-control"
              value={formData.description}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="mt-5 text-right mx-4">
          <button className="btn btn-lg addbtn" disabled={loading}>
            Add Plan
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddPlan;
